// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/transmitter.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { SignalDescriptor, SignalDescriptorJson } from "./signal_descriptor_pb";
import { file_mochabugapis_adapt_graph_v1_signal_descriptor } from "./signal_descriptor_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/transmitter.proto.
 */
export const file_mochabugapis_adapt_graph_v1_transmitter: GenFile = /*@__PURE__*/
  fileDesc("Ci1tb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvdHJhbnNtaXR0ZXIucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSLwAwoLVHJhbnNtaXR0ZXISMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBIcCgVsYWJlbBgCIAEoCUIIukgFcgMY+gFIAIgBARIiCgtkZXNjcmlwdGlvbhgDIAEoCUIIukgFcgMY+gFIAYgBARKwAQoHc2lnbmFscxgEIAMoCzItLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5TaWduYWxEZXNjcmlwdG9yQnC6SG26AWQKFHNpZ25hbHNfdW5pcXVlX25hbWVzEiRFYWNoIHNpZ25hbCBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aJnRoaXMubWFwKHNpZ25hbCwgc2lnbmFsLm5hbWUpLnVuaXF1ZSgpkgEDEIAEEkAKBG1vZGUYBSABKA4yLS5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGgudjEuVHJhbnNtaXR0ZXIuTW9kZUgCiAEBIlIKBE1vZGUSFAoQTU9ERV9VTlNQRUNJRklFRBAAEhEKDU1PREVfU1RBTkRBUkQQARIPCgtNT0RFX1NUUkVBTRACEhAKDE1PREVfRkFJTFVSRRADQggKBl9sYWJlbEIOCgxfZGVzY3JpcHRpb25CBwoFX21vZGViBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_signal_descriptor]);

/**
 * Transmitter represents an output point for a vertex, emitting multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Transmitter
 */
export type Transmitter = Message<"mochabugapis.adapt.graph.v1.Transmitter"> & {
  /**
   * Identifier for the transmitter, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional human-readable label for the transmitter, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string | undefined;

  /**
   * Optional descriptive text for the transmitter's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * List of signals the transmitter can emit. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalDescriptor signals = 4;
   */
  signals: SignalDescriptor[];

  /**
   * An optional mode for the transmitter, indicating its operational context.
   * If not set, it defaults to the standard mode
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.Transmitter.Mode mode = 5;
   */
  mode?: Transmitter_Mode | undefined;
};

/**
 * Transmitter represents an output point for a vertex, emitting multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Transmitter
 */
export type TransmitterJson = {
  /**
   * Identifier for the transmitter, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional human-readable label for the transmitter, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string;

  /**
   * Optional descriptive text for the transmitter's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * List of signals the transmitter can emit. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalDescriptor signals = 4;
   */
  signals?: SignalDescriptorJson[];

  /**
   * An optional mode for the transmitter, indicating its operational context.
   * If not set, it defaults to the standard mode
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.Transmitter.Mode mode = 5;
   */
  mode?: Transmitter_ModeJson;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.Transmitter.
 * Use `create(TransmitterSchema)` to create a new message.
 */
export const TransmitterSchema: GenMessage<Transmitter, {jsonType: TransmitterJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_transmitter, 0);

/**
 * The type of the transmitter.
 *
 * @generated from enum mochabugapis.adapt.graph.v1.Transmitter.Mode
 */
export enum Transmitter_Mode {
  /**
   * Default value indicating the mode is not explicitly set.
   *
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Transmitter is transmitting with the standard mode. I.e. a single transmission
   *
   * @generated from enum value: MODE_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * Transmitter is transmitter with stream. I.e. multiple transmissions
   *
   * @generated from enum value: MODE_STREAM = 2;
   */
  STREAM = 2,

  /**
   * Transmitter is transmitting a failure. I.e. a single transmission with a failure flag
   *
   * @generated from enum value: MODE_FAILURE = 3;
   */
  FAILURE = 3,
}

/**
 * The type of the transmitter.
 *
 * @generated from enum mochabugapis.adapt.graph.v1.Transmitter.Mode
 */
export type Transmitter_ModeJson = "MODE_UNSPECIFIED" | "MODE_STANDARD" | "MODE_STREAM" | "MODE_FAILURE";

/**
 * Describes the enum mochabugapis.adapt.graph.v1.Transmitter.Mode.
 */
export const Transmitter_ModeSchema: GenEnum<Transmitter_Mode, Transmitter_ModeJson> = /*@__PURE__*/
  enumDesc(file_mochabugapis_adapt_graph_v1_transmitter, 0, 0);

